import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const fightingMasteryModule = namespace('fightingMasteries');
let CharactersFightingMasteries = class CharactersFightingMasteries extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Fighting Masteries';
    }
    created() {
        this.fetchFightingMasteries();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        const page = this.isInHandbook ? 'phb' : 'characters';
        return _(this.fightingMasteries)
            .filter(({ contentType }) => !this.isInHandbook || contentType === 'Core')
            .map(fightingMastery => ({
            ...fightingMastery,
            id: fightingMastery.name,
            isExpandable: fightingMastery.text
        })).value();
    }
    get headers() {
        return [
            {
                text: 'Name',
                value: 'name'
            },
            {
                text: 'Source',
                value: 'contentSource',
                render: _.startCase,
                filterChoices: ['PHB', 'EC', 'WH'],
                filterFunction: ({ contentSource }, filterValue) => _.startCase(contentSource) === filterValue
            }
        ];
    }
};
__decorate([
    fightingMasteryModule.State
], CharactersFightingMasteries.prototype, "fightingMasteries", void 0);
__decorate([
    fightingMasteryModule.Action
], CharactersFightingMasteries.prototype, "fetchFightingMasteries", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CharactersFightingMasteries.prototype, "isInHandbook", void 0);
CharactersFightingMasteries = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], CharactersFightingMasteries);
export default CharactersFightingMasteries;
